function isElementVisible(activeElement, ancestorElement) {
  // this function takes two elements and determines if the activeElement
  // is *fully* visible in the field of view for the ancestorElement.

  // activeElement dimensions
  const { offsetTop, offsetHeight } = activeElement;
  const elementBottom = offsetHeight + offsetTop;

  // boundaries for the ancestorElement
  const containerTop = ancestorElement.scrollTop;
  const containerBottom =
    ancestorElement.scrollTop + ancestorElement.offsetHeight;

  const above = offsetTop < containerTop;
  const below = elementBottom > containerBottom;
  const topIsWithin = offsetTop >= containerTop && offsetTop < containerBottom;
  const bottomIsWithin =
    elementBottom <= containerBottom && elementBottom > containerTop;

  const visibility = {
    contained: !above && !below,
    above,
    below,
    topIsWithin,
    bottomIsWithin
  };

  return visibility;
}

export { isElementVisible };

